module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "art",
      "src": "images/Art_P002.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fmh1"
  }, [_c('strong', [_vm._v("THE FUTURE H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMEMAKERS OF AMERICA")])])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('em', [_vm._v("The Future Homemakers of America")]), _vm._v(" is Laurie Graham's sixth novel. Laurie is a former "), _c('em', [_vm._v("Daily Telegraph")]), _vm._v(" columnist and Contributing Editor for "), _c('em', [_vm._v("Cosmopolitan.")]), _vm._v(" She lives in Italy and is currently writing a screenplay of her novel "), _c('em', [_vm._v("The Dress Circle.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60fcb597","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FutureHomemake_fron-1.vue
// module id = 66
// module chunks = 0